import CityPage from "../CityPage";

export default function Shorewood() {
  return <CityPage slug="shorewood" />;
}
